import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { CompanyService } from 'src/app/admin/services/company.service';
import { Company } from 'src/app/user/model/user';
import { CompanyContextService } from 'src/app/shared/services/company-context.service';
import { TravelBoardService } from '../../services/travel-board.service';

@Component({
  selector: 'app-transfer-trip-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    DialogModule,
    SelectModule,
    ButtonModule,
  ],
  templateUrl: './transfer-trip-dialog.component.html',
})
export class TransferTripDialogComponent implements OnInit {
  private companyService = inject(CompanyService);
  private companyContextService = inject(CompanyContextService);
  travelBoardService = inject(TravelBoardService);

  companies: { value: string; label: string }[] = [];
  selectedCompanyId?: string;
  isTransferring = false;
  isLoading = true;

  ngOnInit() {
    this.loadCompanies();
  }

  private loadCompanies() {
    this.isLoading = true;
    // Use effective company ID (acting company if super admin, own company otherwise)
    // This ensures we filter out the company the trip currently belongs to
    const effectiveCompanyId = this.companyContextService.effectiveCompanyId();

    this.companyService.getCompanyList().subscribe({
      next: (companies: Company[]) => {
        // Filter out the company the trip belongs to (effective company) and format for dropdown
        this.companies = companies
          .filter((company) => company.id !== effectiveCompanyId)
          .map((company) => ({
            value: company.id!,
            label: company.name || 'Unnamed Company',
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading companies:', error);
        this.isLoading = false;
      },
    });
  }

  onTransfer() {
    const tripId = this.travelBoardService.transferTripId();
    if (!this.selectedCompanyId || !tripId) return;

    this.isTransferring = true;
    this.travelBoardService.transferTrip(this.selectedCompanyId);
  }

  onClose() {
    this.selectedCompanyId = undefined;
    this.isTransferring = false;
    this.travelBoardService.closeTransferDialog();
  }

  get selectedCompanyName(): string {
    return (
      this.companies.find((c) => c.value === this.selectedCompanyId)?.label ||
      ''
    );
  }
}
